import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import useToken from 'hooks/useToken';
import './NotificacionCumple.css';
import BirthdayModal from './BirthdayModal';
import { useToast } from 'context/providers/ToastProvider';

const NotificacionCumple = () => {
    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();
    const [cargando, setCargando] = useState(true);
    const [cumpleanios, setCumpleanios] = useState([]);
    const [cumpleaniosHoy, setCumpleaniosHoy] = useState([]);
    const [showBirthdayModal, setShowBirthdayModal] = useState(false);

    const ObtenerCumpleanos = async () => {
        setCargando(true);
        const response = await fetch("/api/home/ObtenerCumpleanos", {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch: ' + error);
                console.log('Hubo un problema con la peticion Fetch: ' + error.message);
            });

        if (response && response.ok) {
            console.log(response);
            const data = await response.json();
            console.log(data);

            if (data['table1'][0].iResponseType == 1) {
                console.log("FECHA DE CUMPLEAÑOS")

                setCumpleanios(data['table2']);
                
                const hoy = new Date().getDate();
                const cumpleaniosDelDia = data['table2'].filter(cumple => cumple.dia === hoy);
                setCumpleaniosHoy(cumpleaniosDelDia);
            }
            else {
                showErrorToast(data['table1'][0].vMessage);
            }
        }
        else if (response) {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setCargando(false);
    };

    useEffect(() => {
        ObtenerCumpleanos()
    }, [])

    const obtenerNombresCumpleaneros = () => {
        if (!cumpleaniosHoy || cumpleaniosHoy.length === 0) {
            return '';
        }
        
        if (cumpleaniosHoy.length === 1) {
            return cumpleaniosHoy[0].vNombre;
        } else if (cumpleaniosHoy.length === 2) {
            return cumpleaniosHoy[0].vNombre + ' y ' + cumpleaniosHoy[1].vNombre;
        } else {
            const nombres = cumpleaniosHoy.slice(0, -1).map(c => c.vNombre).join(', ');
            return nombres + ' y ' + cumpleaniosHoy[cumpleaniosHoy.length - 1].vNombre;
        }
    };

    return (
        <>
            {!cargando && cumpleanios.length > 0 && (
                <>
                    {cumpleaniosHoy.length > 0 && (
                        <Card className="mb-3 cumple-card-highlight">
                            <Card.Body className="fs--1">
                                <Flex>
                                    <FontAwesomeIcon icon="gift" className="fs-5 text-danger cumple-icon-animated" />
                                    <div className="ms-2 flex-1">
                                        <strong>¡Feliz Cumplea&ntilde;os!</strong> Hoy {cumpleaniosHoy.length === 1 ? 'celebra' : 'celebran'} {cumpleaniosHoy.map((d, index) => {
                                            return <span key={index}>
                                                <Link className="fw-semi-bold" to={"/perfil/" + cumpleaniosHoy[index].idUsuario}>{cumpleaniosHoy[index].vNombre}</Link>
                                                {index < cumpleaniosHoy.length - 1 && (index === cumpleaniosHoy.length - 2 ? ' y ' : ', ')}
                                            </span>
                                        })}. Todo el equipo de Akasia Software Development {cumpleaniosHoy.length === 1 ? 'le desea' : 'les desea'} un feliz cumplea&ntilde;os!!!
                                        {' '}
                                        <span 
                                            className="cumple-surprise-link"
                                            onClick={() => setShowBirthdayModal(true)}
                                        >
                                            ?? Descubre una sorpresa
                                        </span>
                                    </div>
                                </Flex>
                            </Card.Body>
                        </Card>
                    )}

                    {cumpleaniosHoy.length === 0 && (
                        <Card className="mb-3">
                            <Card.Body className="fs--1">
                                <Flex>
                                    <FontAwesomeIcon icon="gift" className="fs-5 text-info" />
                                    <div className="ms-2 flex-1">
                                        En este mes celebramos cumplea&ntilde;os: {cumpleanios.map((d, index) => {
                                            return <span key={index}>el {cumpleanios[index].dia} festeja <Link className="fw-semi-bold" to={"/perfil/" + cumpleanios[index].idUsuario}>{cumpleanios[index].vNombre}</Link>{index < cumpleanios.length - 1 && <b>,</b>} </span>
                                        })}. Todo el equipo de Akasia Software Development les deseamos un feliz cumplea&ntilde;os!!!
                                    </div>
                                </Flex>
                            </Card.Body>
                        </Card>
                    )}
                </>
            )}

            {cumpleaniosHoy.length > 0 && (
                <BirthdayModal 
                    show={showBirthdayModal}
                    handleClose={() => setShowBirthdayModal(false)}
                    nombresCumpleaneros={obtenerNombresCumpleaneros()}
                />
            )}
        </>
    );
};

export default NotificacionCumple;
